export default "__VITE_ASSET__57b3521b__"